export default __webpack_public_path__ + "src/assets/icn-toast-progress.3b14d9c81fd78b042425a94aafe65562.svg";